import {
  PAYROLL_SETTING_FETCHING,
  PAYROLL_SETTING_FAILED,
  PAYROLL_SETTING_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PAYROLL_SETTING_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PAYROLL_SETTING_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PAYROLL_SETTING_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
